import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import { AppTheme, AppStyles } from '../styles/AppTheme';
import { BaseEntityPage } from '../common/components/BaseEntityPage';

export class DashboardAdmin extends BaseEntityPage {
  constructor(props) {
    super(props);
    this.pageTitle = 'Admin Dashboard'.toLocaleUpperCase()
    this.toFetch = []
  }

  renderCustomReady() {
    const largeTiles = [
      { title: 'Specialties', link: '/admin/cats' },
      { title: 'Brands', link: '/admin/brands' },
      { title: 'Products', link: '/admin/products' },
      { title: 'Orders', link: '/admin/orders' },
    ]
    const smallTiles = [
      { title: 'Lists', link: '/admin/prod-lists' },
      { title: 'Banners', link: '/admin/banners' },
      { title: 'News', link: '/admin/news' },
      { title: 'Partners', link: '/admin/partners' },
      { title: 'Numbers', link: '/admin/numbers' },
      { title: 'Clinics', link: '/admin/orgs' },
    ]
    return (
      <div className={css(AppStyles.containerContentCenter)}>
        <h1 className={css(AppStyles.pageTitle)}>{this.pageTitle}</h1>

        <Grid container spacing={2} className={css(Styles.container)}>
          {largeTiles.map(tile => (
            <Grid key={tile.title} item xs={12} sm={Math.round(12 / largeTiles.length)}>
              <Link to={tile.link} className={css(Styles.link)}>
                <Paper className={css(Styles.tile)}>
                  <h2 className={css(Styles.title)}>{tile.title}</h2>
                </Paper>
              </Link>
            </Grid>
          ))}

          {smallTiles.map(tile => (
            <Grid key={tile.title} item xs={6} sm={Math.max(Math.round(12 / smallTiles.length), 3)}>
              <Link to={tile.link} className={css(Styles.link)}>
                <Paper className={css(Styles.smallTile)}>
                  <h2 className={css(Styles.title)}>{tile.title}</h2>
                </Paper>
              </Link>
            </Grid>
          ))}
        </Grid>

      </div>
    );
  }
}

const Styles = StyleSheet.create({
  container: {
    textAlign: 'center',
    maxWidth: 900
  },
  tile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 200,

    // borderTop: '3px solid ' + AppTheme.secondaryColor,
    minHeight: 80,
    boxShadow: 'none',
    backgroundColor: '#014C5B',
    // backgroundColor: AppTheme.primaryColor,
    '@media (max-width: 600px)': {
      minHeight: 60,
    }
  },
  smallTile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    // borderTop: '1px solid ' + AppTheme.primaryColor,
    minHeight: 50,
    boxShadow: 'none',
    backgroundColor: '#014C5B',
    // backgroundColor: AppTheme.primaryColor,
    '@media (max-width: 600px)': {
      minHeight: 40,
    }
  },
  title: {
    // color: 'black',
    color: 'white',
    fontSize: 16,
    fontWeight: 'normal',
    textTransform: 'uppercase'
  },
  link: {
    textDecoration: 'none',
    color: 'black'
  }
})



// WEBPACK FOOTER //
// ./src/screens/DashboardAdmin.js